import { render, staticRenderFns } from "./NormalSearchNav70.vue?vue&type=template&id=37764644&scoped=true"
import script from "./NormalSearchNav70.vue?vue&type=script&lang=js"
export * from "./NormalSearchNav70.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37764644",
  null
  
)

export default component.exports